export interface SearchActionAvailability {
  export: boolean;
  marketingList: boolean;
  bulkEdit: boolean;
  status: boolean;
}

/** Which actions the searched entity offers; audits are only ever written by the system. */
export function getSearchActionAvailability(entityName: string): SearchActionAvailability {
  return {
    export: true,
    marketingList: entityName === "contact",
    bulkEdit: ["contact", "g4b_productbase"].includes(entityName),
    status: entityName === "contact",
  };
}
